import { BASE_URL } from "../../helpers/common/config";
import axios from "../../helpers/axios/axios";
import { setLoading } from "./app";

export const setTokenPasien = (body) => {
  const url = BASE_URL + "/api/firebase/set-token-pasien";
  return (dispatch, state) => {
    dispatch(setLoading(true));
    return axios
      .post(url, body)
      .then((payload) => {})
      .catch((err) => {})
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};
